<template>
  <div class="home_profile">

    <LayoutTopComponent></LayoutTopComponent>

    <div class="profile_center_one" ref="pagesRef">

      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in companyOneImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>

      <div class="one_container">
        <div class="one_container_home">
          <div class="one_container_home_item">
            <img src="../assets/images/profile_one_001.png"/>
            <div>8年教育+环保</div>
          </div>
          <div class="one_container_home_item">
            <img src="../assets/images/profile_one_002.png"/>
            <div>厂家直销 性价比高</div>
          </div>
          <div class="one_container_home_item">
            <img src="../assets/images/profile_one_003.png"/>
            <div>后台数据监测</div>
          </div>
          <div class="one_container_home_item">
            <img src="../assets/images/profile_one_004.png"/>
            <div>特色设计 专属定制</div>
          </div>
          <div class="one_container_home_item">
            <img src="../assets/images/profile_one_005.png"/>
            <div>周期短 发货快</div>
          </div>
          <div class="one_container_home_item">
            <img src="../assets/images/profile_one_006.png"/>
            <div>服务专业</div>
          </div>
        </div>
      </div>

    </div>

    <div class="profile_center_two">
      <div class="two_title">
        <img src="../assets/images/profile_two_title.png">
      </div>

      <div class="two_center_one">
        <div class="two_center_one_img">
          <img src="../assets/images/profile_two_center_one.png">
        </div>
        <div class="two_center_one_text">
          杭州富从公司成立于2012年9月的国家高新技术企业，以教育和环卫行业发展为导向，以开发智能化硬件为己任。品质至上，不走捷径，踏踏实实，厚积薄发；以客户为中心,以服务为基石，刻苦钻研进行产品设计。
        </div>
      </div>

      <div class="two_center_two">
        <div class="two_center_one_img">
          <img src="../assets/images/profile_two_center_one.png">
        </div>
        <div class="two_center_two_text">
          杭州富从以智能硬件为切入点与移动、电信、联通一起打造平安校园，筑牢安全底线。以刷卡机、访客机、闸机、班牌等设备为载体，通过人脸识别、指纹、二维码、刷卡等识别方式规范学校安全
        </div>
      </div>

      <div class="two_bottom">
        <div v-for="(item,index) in companyOneTwoBottomImgList" :key="index" class="two_bottom_item">
          <img :src="item.url">
        </div>
      </div>

      <div class="two_bottom_title">
        <div class="two_bottom_title_line"></div>
        <div class="two_bottom_title_content">发展历程</div>
        <div class="two_bottom_title_line"></div>
      </div>

    </div>

    <div class="profile_center_three">

      <div class="three_top" v-for="(item,index) in threeBody" :key="index">
        <div class="three_top_left">
          <!--          <img src="../assets/images/home_three_002.png">-->
          <img @click="toDetail(item.year)" :src="item.img">
        </div>
        <div class="three_top_riht">
          <div class="three_top_right_title">{{ item.title }}</div>
          <div class="three_top_right_content">{{ item.content }}</div>
        </div>
      </div>

      <div class="three_bottom">
        <div class="three_bottom_line"></div>

        <div class="three_bottom_list" v-for="item in threeList">
          <div :class="threeBottomCircleShow(item.isSelect)" @click="click2013(item)">
            <div class="three_bottom_circle_text">{{ item.title }}</div>
          </div>
          <div class="three_bottom_line"></div>
        </div>
      </div>

    </div>

    <div class="profile_center_four">

      <div class="four_top">
        <img src="../assets/images/profile_four_001.png">
      </div>
      <div class="four_bottom">
        <el-carousel type="card" :autoplay="true" :interval="5000" height="520px">
          <el-carousel-item v-for="(item,index) in fourBottomImgList" :key="index" class="four_bottom_item">
            <img style="" :src="item.url" oncontextmenu="return false;">
          </el-carousel-item>
        </el-carousel>
      </div>

    </div>

    <div class="profile_center_five">
      <div class="five_top">
        <img src="../assets/images/profile_five_001.png">
      </div>
      <div class="five_bottom">
        <div v-for="(item,index) in fiveBottomList" :key="index" class="five_bottom_item">
          <img :src="item.url">
        </div>
      </div>

    </div>

    <LayoutBottomComponent></LayoutBottomComponent>

  </div>
</template>


<script>

import LayoutTopComponent from "../components/LayoutTopComponent";
import LayoutBottomComponent from "../components/LayoutBottomComponent";

export default {
  data() {
    return {
      threeList: [
        {
          title: "2013",
          isSelect: false
        },
        {
          title: "2014",
          isSelect: false
        },
        {
          title: "2015",
          isSelect: false
        },
        {
          title: "2016",
          isSelect: false
        },
        {
          title: "2017",
          isSelect: false
        },
        {
          title: "2018",
          isSelect: false
        },
        {
          title: "2019",
          isSelect: false
        },
        {
          title: "2020",
          isSelect: false
        },
        {
          title: "2021",
          isSelect: true
        }
      ],
      threeBody: [
        {
          year: "2021",
          title: "新智能回收柜",
          content: "智能回收柜是一款放置在小区室外公共区域的智能设备，主要用于居民自助投放废品（如纸类、塑料、金属、织物、有害垃圾）。居民可凭手机APP、智能IC卡、人脸识别任何一种方式进行身份识别，选择需要投放废品的种类。设备内具备称重功能，进行称重后掉落到存储空间。此产品实现小区居民废品的快速交投，并通过用户识别及称重，实现实时废品线上奖励。可以实现基础再生资源、图书、织物等物品的回收。",
          img: require("../assets/images/desc_bottom_blhsg03.png")
        }
      ],
      pagesHeight: '',
      companyOneImgList: [
        {
          url: require("../assets/images/profile_banner.png")
        },
        {
          url: require("../assets/images/profile_banner.png")
        },
        {
          url: require("../assets/images/profile_banner.png")
        },
      ],
      companyOneTwoBottomImgList: [
        {
          url: require("../assets/images/profile_two_001.png")
        },
        {
          url: require("../assets/images/profile_two_002.png")
        },
        {
          url: require("../assets/images/profile_two_003.png")
        },
        {
          url: require("../assets/images/profile_two_004.png")
        },
      ],
      fourBottomImgList: [
        {
          url: require("../assets/images/profile_credential_006.png")
        },
        {
          url: require("../assets/images/profile_credential_007.png")
        },
        {
          url: require("../assets/images/profile_credential_008.png")
        }, {
          url: require("../assets/images/profile_credential_009.png")
        },
        {
          url: require("../assets/images/profile_credential_010.png")
        }, {
          url: require("../assets/images/profile_credential_011.png")
        },
        {
          url: require("../assets/images/profile_credential_013.png")
        },
        {
          url: require("../assets/images/profile_credential_014.png")
        }, {
          url: require("../assets/images/profile_credential_015.png")
        },
        {
          url: require("../assets/images/profile_credential_016.png")
        }, {
          url: require("../assets/images/profile_credential_017.png")
        },
        {
          url: require("../assets/images/profile_credential_019.png")
        },
      ],
      fiveBottomList: [
        {
          url: require("../assets/images/profile_five_002.png")
        },
        {
          url: require("../assets/images/profile_five_003.png")
        },
        {
          url: require("../assets/images/profile_five_004.png")
        },
        {
          url: require("../assets/images/profile_five_005.png")
        }
      ]
    }
  },
  mounted() {
    this.pagesHeight = this.$refs.pagesRef.clientHeight;
  },
  components: {
    LayoutTopComponent,
    LayoutBottomComponent
  },
  methods: {
    toDetail: function (res) {

      console.log(res)

      switch (res) {
        case "2013":
          this.$router.push("/Detail?&type=VTYHV1")
          break
        case "2014":
          this.$router.push("/Detail?&type=KG4002")
          break
        case "2015":
          this.$router.push("/Detail?&type=FK4151")
          break
        case "2016":
          this.$router.push("/Detail?&type=BL2FL01")
          break
        case "2017":
          this.$router.push("/Detail?&type=ZJ4362")
          break
        case "2018":
          this.$router.push("/Detail?&type=HC3620")
          break
        case "2019":
          this.$router.push("/Detail?&type=ZJ4361")
          break
        case "2020":
          this.$router.push("/Detail?&type=BL3FL02")
          break
        case "2021":
          this.$router.push("/Detail?&type=BLHSG03")
          break
      }
    },
    threeBottomCircleShow: function (res) {
      if (res) {
        return 'three_bottom_circle_select'
      } else {
        return 'three_bottom_circle'
      }
    },
    click2013: function (res) {

      let mlist = this.threeList;
      for (let index in mlist) {
        if (res.title == mlist[index].title) {
          mlist[index].isSelect = true;
          this.select2013Body(mlist[index].title);
        } else {
          mlist[index].isSelect = false;
        }
      }
      this.threeList = mlist;
    },
    select2013Body: function (index) {
      switch (index) {
        case "2013":
          this.threeBody = [
            {
              year: index,
              title: "油耗检测仪",
              content: "本产品是富从研发支持嵌入式系统的智能油耗检测设备，应用超声波测量技术对油箱内的油位高度进行测量，并经过电路处理后输出标准电信号。",
              img: require("../assets/images/desc_bottom_vtyhv1.png")
            }]
          break
        case "2014":
          this.threeBody = [
            {
              year: index,
              title: "幼教智能刷卡机",
              content: "幼教刷卡机是智能高清网络设备，集安全、考勤、管 理、信息发布等诸多功能于一体，是幼儿园实行科学管 理的好帮手，是幼儿园亲子活动、校园活动的最佳宣传工具。",
              img: require("../assets/images/desc_bottom_kg4002.png")
            }]
          break
        case "2015":
          this.threeBody = [
            {
              year: index,
              title: "双屏智能终端访客一体机",
              content: "本产品是一款基于Android系统，集成双屏显示、二代身份证读卡器、指纹读取、IC读卡器、ID读卡器、电容触摸、高速热敏打印、二维码/条码扫描仪、摄像头等多个模块。",
              img: require("../assets/images/desc_bottom_fk4151.png")
            }]
          break
        case "2016":
          this.threeBody = [
            {
              year: index,
              title: "智能垃圾分类箱",
              content: "整体设计简洁硬朗，线条、棱角鲜明。该设备内置满溢检测、称重检测等多种传感器，时刻检测箱体内部状态，保障设备正常运行。箱体内部有IC/ID读卡，二维码扫码，触摸按键，10.1寸显示屏，投放照明灯等功能部件，用户通过刷卡或将居民卡二维码放置到扫码区域，打开垃圾投放口，投递垃圾获取相应的积分奖励， 管理员可以通过刷卡打开清运门。",
              img: require("../assets/images/desc_bottom_bl2fl01.png")
            }]
          break
        case "2017":
          this.threeBody = [
            {
              year: index,
              title: "自主研发闸机",
              content: "产品包括外壳机箱、机芯、摆臂、驱动器电路板、红外传感器、刷卡读头、闸机控制系统、门禁控制系统八大部分。",
              img: require("../assets/images/desc_bottom_zj4362.png")
            }]
          break
        case "2018":
          this.threeBody = [
            {
              year: index,
              title: "智能回收秤",
              content: "智能回收秤是应用在垃圾分类过程中的可回收废品回收环节，由环卫人员在居民社区对回收物品的称重、打印回收信息纸、刷居民卡、扫描二维码等功能，实现回收物品与居民信息关联，从而实现垃圾回收兑换积分，增强居民的垃圾回收意识，促进垃圾分类规范。",
              img: require("../assets/images/desc_bottom_hc3620.png")
            }]
          break
        case "2019":
          this.threeBody = [
            {
              year: index,
              title: "不锈钢闸机",
              content: "产品包括外壳机箱、机芯、摆臂、驱动器电路板、红外传感器、刷卡读头、闸机控制系统、门禁控制系统八大部分。",
              img: require("../assets/images/desc_bottom_zj4361.png")
            },
          ]
          break
        case "2020":
          this.threeBody = [
            {
              year: index,
              title: "智能三分类箱",
              content: "整体设计简洁硬朗，线条、棱角鲜明。该设备内置满溢检测、称重检测等多种传感器，时刻检测箱体内部状态，保障设备正常运行。箱体内部有IC/ID读卡，10.1寸显示屏，投放照明灯等功能部件，用户通过刷卡或人体感应打开垃圾投放口，投递垃圾获取相应的积分奖励。",
              img: require("../assets/images/desc_bottom_bl3fl02.png")
            },
          ]
          break
        case "2021":
          this.threeBody = [
            {
              year: index,
              title: "新智能回收柜",
              content: "智能回收柜是一款放置在小区室外公共区域的智能设备，主要用于居民自助投放废品（如纸类、塑料、金属、织物、有害垃圾）。居民可凭手机APP、智能IC卡、人脸识别任何一种方式进行身份识别，选择需要投放废品的种类。设备内具备称重功能，进行称重后掉落到存储空间。此产品实现小区居民废品的快速交投，并通过用户识别及称重，实现实时废品线上奖励。可以实现基础再生资源、图书、织物等物品的回收。",
              img: require("../assets/images/desc_bottom_blhsg03.png")
            },
          ]
          break
      }

    }
  }
}
</script>

<style lang="less" scoped>

@import "../assets/css/common";

@media screen and (max-width: 1280px) {

  .home_profile {
    width: @screenWidth1280;
    margin-top: @layoutTopHight1280;
    // 首页轮播图
    .profile_center_one {
      height: @viewPager1280;

      .imgCls {
        width: 100%;
        height: @viewPager1280;
      }
    }
  }

  .two_bottom {
    margin: 40px 0px;
  }

  .two_center_two {
    margin: 52px 0 0 276px;

    .two_center_one_text {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .three_bottom_circle {
    width: 80px;
    height: 80px;
  }

  .three_bottom_circle_select {
    width: 80px;
    height: 80px;
  }

  .three_bottom_line {
    width: 52px;
    height: 10px;
  }

  .three_bottom_circle_text {
    font-size: 20px;
  }

  .five_top {
    margin-top: 80px;
  }

  .five_bottom {
    margin: 49px 15px 49px;
  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .home_profile {
    width: @screenWidth1440;
    margin-top: @layoutTopHight1440;
    // 首页轮播图
    .profile_center_one {
      height: @viewPager1440;

      .imgCls {
        width: 100%;
        height: @viewPager1440;
      }
    }
  }

  .two_center_two {
    margin: 52px 0 0 553px;

    .two_center_one_text {
      font-size: 18px;
      line-height: 30px;
    }

  }

  .two_bottom {
    margin: 42px 0px;
  }

  .three_bottom_circle {
    width: 100px;
    height: 100px;
  }

  .three_bottom_circle_select {
    width: 100px;
    height: 100px;
  }

  .three_bottom_line {
    height: 10px;
    width: 52px;
  }

  .three_bottom_circle_text {
    font-size: 20px;
  }

  .five_top {
    margin-top: 105px;
  }

  .five_bottom {
    margin: 49px 49px 49px;
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .home_profile {
    width: @screenWidth1920;
    margin-top: @layoutTopHight1920;
    // 首页轮播图
    .profile_center_one {
      height: @viewPager1920;

      .imgCls {
        width: 100%;
        height: @viewPager1920;
      }
    }
  }

  .two_bottom {
    margin: 49px 132px;
  }

  .two_center_two {
    margin: 52px 0 0 720px;

    .two_center_one_text {
      font-size: 20px;
      line-height: 30px;
    }

  }

  .three_bottom_circle {
    width: 112px;
    height: 112px;
  }

  .three_bottom_circle_select {
    width: 112px;
    height: 112px;
  }

  .three_bottom_line {
    height: 21px;
    width: 72px;
  }

  .three_bottom_circle_text {
    font-size: 30px;
  }

  .five_top {
    margin-top: 118px;
  }

  .five_bottom {
    margin: 49px 245px 49px;
  }

}


.home_profile {

  display: flex;
  flex-direction: column;

  .profile_center_one {
    position: relative;

    .one_container {
      position: absolute;
      width: 1200px;
      height: 140px;
      background: white;
      bottom: -70px;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      z-index: 999;

      .one_container_home {
        display: flex;
        justify-content: space-around;
        width: 100%;
        align-items: center;
        margin: 0 88px 0 88px;

        .one_container_home_item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .item_top {

          }

          .item_bottom {
            width: 98px;
            height: 16px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #101010;
          }

        }


      }

    }

  }

  .profile_center_two {
    display: flex;
    flex-direction: column;
    background: #f5f5f5;

    .two_title {
      margin-top: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .two_center_one {
      display: flex;
      margin-left: 280px;

      .two_center_one_text {
        text-align: left;
        margin: 48px 480px 0 52px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2A57EA;
        line-height: 30px;
      }
    }

    .two_center_two {
      display: flex;

      .two_center_two_text {
        text-align: left;
        margin: 0 375px 0 39px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2A57EA;
        line-height: 30px;
      }
    }

    .two_bottom {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;

      .two_bottom_item {
      }
    }

    .two_bottom_title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 25px;

      .two_bottom_title_content {
        width: 203px;
        font-size: 48px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FDA12B;
        line-height: 77px;
      }

      .two_bottom_title_line {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 182px;

        height: 4px;
        background: #BBBBBB;
      }
    }

  }

  .profile_center_three {
    display: flex;
    flex-direction: column;
    height: 740px;
    background: url("../assets/images/home_three_back.png");

    .three_top {

      display: flex;

      .three_top_left {
        margin: 86px 0 0 180px;
        width: 478px;
        height: 396px;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .three_top_riht {
        text-align: left;

        .three_top_right_title {
          margin: 100px 0 0 77px;
          font-size: 48px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #FBFBFA;
          line-height: 77px;
        }

        .three_top_right_content {
          margin: 42px 24px 0 77px;
          width: 700px;
          height: 89px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #FBFBFA;
          line-height: 40px;
        }

      }

    }

    .three_bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 76px 0 52px 0;

      .three_bottom_line {
        background: url("../assets/images/profile_three_002.png");
      }

      .three_bottom_list {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .three_bottom_circle {
          background: url("../assets/images/profile_three_003.png");
          background-repeat: no-repeat;
          background-size: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          .three_bottom_circle_text {
            color: #2A57EA;
          }
        }


        .three_bottom_circle_select {
          background: url("../assets/images/profile_three_004.png");
          background-repeat: no-repeat;
          background-size: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          .three_bottom_circle_text {
            color: #2A57EA;
          }

        }
      }

    }

  }

  .profile_center_four {
    display: flex;
    flex-direction: column;
    background: #fefefe;
    height: 749px;

    .four_top {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 118px;
    }

    .four_bottom {
      margin: 49px 120px 0px;

      .four_bottom_item {
        height: 520px;

        img {
          height: 520px;
        }

      }
    }

  }

  .profile_center_five {
    display: flex;
    flex-direction: column;
    background: #2A57EA;

    .five_top {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .five_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .five_bottom_item {
      }

    }

  }

}


</style>

